<form>
    <label class="toggle-switch clearfix" *ngIf="showSettings.createLayerForEachGraphic">
        <span class="togggle-switch-label left font-size--1">Create a seperate layer for each graphic</span>
        <input type="checkbox" name="seperate" class="toggle-switch-input" [(ngModel)]="createLayerForEachGraphic"
               checked>
        <span class="toggle-switch-track right"></span>
    </label>
    <div class="setting" *ngIf="showSettings.style">
        <label for="style"> Point Style </label>
        <select id="style" name="style" [(ngModel)]="selectedOption" (ngModelChange)="updateStyle($event);">
            <option *ngFor="let option of pointStyleOptions;" [ngValue]="option">{{ option.name }}</option>
        </select>
    </div>
    <div class="setting" *ngIf="selectedOption && selectedOption.value === 'path' && !selectedOption.path || showSettings.style">
        <label for="svgPath"> Point SVG Path </label>
        <input placeholder="SVG Path" name="svgPath" [(ngModel)]="symbolProperties.path" />
    </div>
    <div class="setting" *ngIf='showSettings.size'>
        <label for="size"> Point Size </label>
        <select id="size" name="size" [(ngModel)]="symbolProperties.size">
            <option *ngFor="let option of pointSizeOptions" [value]="option">{{ option }}</option>
        </select>
    </div>
    <div class="setting" *ngIf="showSettings.fillColor">
        <label for="color" (click)="colorPicker.showColorPicker = true;">Fill Color</label>
        <mc-color-picker-ng #colorPicker
                            [(color)]="symbolProperties.color"
                            [siblingColorPickers]="[outlineColorPicker]">
        </mc-color-picker-ng>
    </div>
    <div class="setting" *ngIf="showSettings.outlineColor">
        <label for="outline-color" (click)="outlineColorPicker.showColorPicker = true;">Outline Color</label>
        <mc-color-picker-ng #outlineColorPicker
                            [(color)]="symbolProperties.outline.color"
                            [siblingColorPickers]="[colorPicker]">
        </mc-color-picker-ng>
    </div>
    <div class="setting" *ngIf="showSettings.outlineWidth">
        <label for="outlineWidth"> Outline Width </label>
        <input name="outlineWidth" type="number" min="0" [(ngModel)]="symbolProperties.outline.width" />
    </div>
    <div class="setting" *ngIf="showSettings.coordinates">
        <label for="coords"> Point Coordinates </label>
        <select id="coords" name="coords" [(ngModel)]="selectedCoordsStyle">
            <option *ngFor="let option of CoordinateStyles">{{ option }}</option>
        </select>
    </div>
</form>
